import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './Section';
const CASES = ['Venís de Android y es tu primer iPhone.', 'Ya usás iPhone y querés aprovecharlo mejor.', 'Usás iPhone y todavía no te acostumbrás.'];
export function WhoIsItFor() {
  return <Section className="bg-cream-100 py-12 sm:py-16" data-id="element-284" data-mp="hzke4ip3uqtn">
      <h2 className="text-2xl font-extrabold tracking-tight text-ink-950 sm:text-3xl" data-id="element-285" data-mp="i157i4zoo3px">Esto te sirve si...</h2>
      <ul className="mt-6 grid gap-2.5 md:grid-cols-3" data-id="element-286" data-mp="1fmj8unw8loow">
        {CASES.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-ink-950/10 bg-white px-5 py-4 text-sm font-medium leading-relaxed text-ink-900" data-id="element-287" data-mp="1aork22qw2iox">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-deep" aria-hidden="true" data-id="element-288" data-mp="10y6chpt8m3tv" />
            {item}
          </li>)}
      </ul>
    </Section>;
}